import { ProductType } from '@inter-ikea-storageone/range';
import { hideDoors } from 'ducks/layout';
import { noProductsWithTypesForSelectedEntity } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import removeAllInteriorsFromSelectedFrame from '../behaviors/removeAllInteriorsFromSelectedFrame';

export const noneOptionForInteriorSuggestions = {
  behaviors: {
    removeProducts: [removeAllInteriorsFromSelectedFrame],
    productClicked: [hideDoors]
  },
  selected: noProductsWithTypesForSelectedEntity([
    ProductType.JONAXEL_CLOTH_RAIL_ADJUSTABLE,
    ProductType.JONAXEL_FRAME_SHELF,
    ProductType.JONAXEL_MESH_BASKET,
    ProductType.JONAXEL_TOP_SHELF,
    ProductType.JONAXEL_WIRE_BASKET
  ]),
  title: 'storageone.productListNoInteriorsOptionTitle',
  subtitle: 'storageone.productListNoInteriorsSubtitle'
} as any;
